import { FC, css } from "dreamland/core";
import TransitionLink from "../components/TransitionLink";
import ContactLinks from "../components/ContactLinks";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getBlogMetadata, type BlogModule } from "../lib/blog";
import { getWebpPath } from "../lib/images";

const blogModules = import.meta.glob<BlogModule>("../blog/*.mdx", {
	eager: true,
});

const blogPosts = Object.entries(blogModules)
	.map(([path, module]) => getBlogMetadata(path, module))
	.filter((post): post is NonNullable<typeof post> => post !== null)
	.sort((a, b) => b.date.localeCompare(a.date));

function getCoverStyle(image: string | undefined) {
	if (!image) return undefined;

	const style: Record<string, string> = {
		"--cover-image": `url("${image}")`,
	};
	const webp = getWebpPath(image);
	if (webp) {
		style["--cover-image-set"] =
			`image-set(url("${webp}") type("image/webp"), url("${image}") type("image/jpeg"))`;
	}
	return style;
}

function BlogList(this: FC) {
	return (
		<main>
			<title>blog – bomberfish.ca</title>
			<div class="layout-container">
				<Navbar active="blog" />
				<div class="main-content">
					<div class="page-header">
						<h1>blog</h1>
						<p>
							various assorted thoughts and ramblings. very infrequently updated
						</p>
					</div>
					<div class="background-container" style="margin-top: 0.5rem;">
						<subt style="font-size: 0.95rem; color: var(--text1)">
							** obligatory disclaimer: all opinions are my own and do not
							reflect those of any employer, past, present, or future.
						</subt>
						<span style="margin-bottom: 0; margin-top: 0.5rem;">
							<subt style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.25rem; margin-bottom: 0;">
								<span class="material-symbols">rss_feed</span> Subscribe:{" "}
								<ul
									class="compact"
									style="display: inline; margin-left: 0.25rem; transform: translateY(-2px);"
								>
									<li>
										<a href="/feed.xml" target="_blank">
											RSS
										</a>
									</li>
									<li>
										<a href="/atom.xml" target="_blank">
											Atom
										</a>
									</li>
									<li>
										<a href="/feed.json" target="_blank">
											JSON Feed
										</a>
									</li>
								</ul>
							</subt>
						</span>
					</div>
					<div class="blog-list">
						{blogPosts.map((post) => (
							<div
								class={`blog-item ${post.image ? "has-cover" : ""}`}
								style={getCoverStyle(post.image)}
							>
								<TransitionLink href={`/blog/${post.slug}`} class="blog-link">
									<h3>{post.title}</h3>
									{post.description ? (
										<p class="post-desc">{post.description}</p>
									) : (
										false
									)}
									<div class="post-footer">
										{post.tags ? (
											<div class="post-tags">
												<span class="material-symbols">label_important</span>
												{post.tags.map((t) => (
													<span class="tag">{t}</span>
												))}
											</div>
										) : (
											<div />
										)}
										<time>{post.date}</time>
									</div>
								</TransitionLink>
							</div>
						))}
					</div>
					<br />
					<span style="font-size: 0.9rem; color: var(--subtext1);">
						<span class="material-symbols">email</span> get in touch:{"    "}
						<ContactLinks />
					</span>
				</div>
				<Footer />
			</div>
		</main>
	);
}

BlogList.style = css`
	p {
		margin: 0;
		margin-bottom: 0.5rem;
	}

	.post-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: auto;
	}
`;

export default BlogList;
